import * as React from "react";

import "./orders-header.scss";

import {
    componentHelper as component,
    valueHelper as value,
    makeChain }          from "@Common/react/cst2";
import {UseState}        from "@Common/react/use-state";
import {Select2}         from "@Common/ui-components/select-2/select-2";
import {
    AGENT_LEVEL,
    COMPANY_LEVEL }      from "@Xpresso/routes/common/logic/user-level"
import {consumeContext}  from "@Xpresso/loaders/consume-context";


import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faArrowDown,
    faArrowUp}            from "@fortawesome/free-solid-svg-icons";

export const OrdersHeader = ({search, sortState: {change: changeSortMode, onChange: setSortMode, value: sortMode}}: {search?: any, sortState?: any}) => makeChain<JSX.Element>()
    .then(...consumeContext("userLevels")) // uses Xpresso wrapper of consumeContext
    .then(...consumeContext("routerHistory"))

    // component node, using type helper. omits manual next. C refers to the component
    .then("searchState", component(UseState as typeof UseState<string>)(
        ({}, C) => C({initValue: ""})
    ))
    // assignment node, using type helper. returned value is passed into next
    .then("sortModes", value(
        ({userLevels: {userLevel}}) => [
            {id: "orderName",   label: "Order Name"},
            {id: "orderId",     label: "Order ID"},
            {id: "type",        label: "Type"},
            {id: "date",        label: "Date"},
            {id: "schDate",     label: "Sch. Fulfillment"},
            {id: "expShipDate", label: "Exp. Ship Date"},

            ...(userLevel === COMPANY_LEVEL ? [{id: "branchName", label: "Office"}] : []),
            ...(userLevel !== AGENT_LEVEL   ? [{id: "agentName", label: "User"}]   : []),
        ]
    ))
    .then(({
        sortModes,
        routerHistory,
    }) => (
        <div className="orders-header-c94i9">
            <a
                className="start-new-order"
                xd-qa-type="link"
                xd-qa-name="Start a New Order"
                onClick={() => routerHistory.push("/")}
                hidden={false}
            >
                Start a New Order
            </a>
            {search}
            {changeSortMode && <div className="group sort-group">
                <Select2
                    list={sortModes}
                    getLabel={({label}) => `Sort by ${label}`}
                    isSelected={({id}) => id === sortMode.id}
                    onSelect={({id}) => setSortMode({id ,ascending: true})}
                    disableClearingSelection={true}

                    title="Choose a sorting method"
                    className="sort-select"
                />
                <button
                    onClick={() => changeSortMode(({ascending, id}) => ({id, ascending: !ascending}))}
                    className="sort-flip"
                ><FontAwesomeIcon icon={sortMode.ascending ? faArrowUp : faArrowDown}/></button>
            </div>}
        </div>
    ))

    .run()
;

